import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { ReactComponent as Logo } from 'src/assets/svgs/logo.svg';
import { ResponsiveImage } from 'src/components/ResponsiveImage';
import {
  mainContentBoxStyles,
  mainContentContainerStyles,
  mainContentLogoStyles,
  mainContentStyles,
  mainHeaderStyles,
  publicImageStyles,
  rightColStyles,
  subtitleStyles,
} from './styles';

type AuthLayoutProp = {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
};

export function AuthLayout({
  title,
  subtitle,
  children,
}: AuthLayoutProp): React.JSX.Element {
  return (
    <Box>
      <Grid container>
        <Grid size={6}>
          <Box sx={publicImageStyles}>
            <ResponsiveImage alt="Diabeasy" imageSrc="login.png" />
          </Box>
        </Grid>
        <Grid sx={rightColStyles} size={6}>
          <Box sx={mainContentContainerStyles}>
            <Box sx={mainContentStyles}>
              <Box sx={mainContentLogoStyles}>
                <Logo title="logo" />
              </Box>
              <Box sx={mainHeaderStyles}>
                <Typography variant="h3">{title}</Typography>
                <Typography sx={subtitleStyles}>{subtitle}</Typography>
              </Box>
              <Box sx={mainContentBoxStyles}>{children}</Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
